import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import impreza from "../../../../assets/info/impreza-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/subaru-impreza/impreza-pcd.png";
import part2 from "../../../../assets/info/subaru-impreza/subaru-impreza-fig-1.jpg";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const SubaruImpreza = () => {
  useSmallNav("Subaru Impreza");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Impreza"} bolder />
        <InfoHero image={impreza} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Subaru Impreza? Looking for suspension parts or suspension upgrades?"
              }
            />
            <p>
              The Subaru Impreza is synonymous with rallying and has always gone
              down a storm with tuning companies with its small 2.0 Turbo
              engine, big bhp/torque and an ability to make much more expensive
              vehicles look completely inadequate.
            </p>
            <p>
              As the Impreza has evolved from the now classic GC & GF series
              (1992-2000), through the years of the Bug, Blob and Hawk eyed GD &
              GG, into the GE & GH (2007-2011) and finally onto the hatchback GV
              (2011 on), there is an Impreza for all budgets and tastes.
            </p>
            <p>
              Here at Pedders Suspension, we believe in offering a choice as to
              how you would like your vehicle to handle, drive and behave.
            </p>
            <p>
              Within the Impreza range, we can offer straight forward
              replacement parts, uprated performance parts including dampers and
              springs, Ezifit Kits, and also the Xa coilover kits for those
              looking for the ultimate in adjustability.
            </p>
            <p>
              To assist you choose the right parts for your car, please read the
              notes below:
            </p>
            <InfoHeader
              size="smaller"
              text={
                "You list lots of different kits and parts, which one do I need?"
              }
            />
            <p>
              There are many different variants of Impreza. Please choose the
              correct one from the menu below to see the options.
            </p>
            <p>
              Shocks. We offer 2 different types of shock. Our Pedders Shock,
              which is black, is, effectively a replacement for the original
              shock. So if you are just looking for replacement shocks to
              replace a defective original, then these are ideal.
            </p>
            <p>
              We also offer the Pedders Sportsryder shock. These are red and are
              uprated for an more performance orientated feel. These can be used
              with the original springs, or our lowering springs for improved
              feel and handling.
            </p>
            <p>
              Springs. Again, we offer both standard replacement coils (black)
              and lowered upgraded items (red).
            </p>
            <p>
              Ezifit Fully Assembled Suspension Kits. In addition to the above,
              we now offer fully assembled ready to fit kits for some models and
              variants. These kits are fully assembled kits, so come complete
              with shocks, springs, top mounts, bump stops and boots, ready to
              bolt straight in. Not only do they offer ease of fitment, the
              knowledge that all the parts are new, they represent exceptional
              value compared to buying the parts separately.
            </p>
            <p>
              Extreme XA Coilover Kits. These are the pinnacle of the Pedders
              range and offer a fully adjustable suspension package aimed at the
              performance enthusiast.
            </p>
            <p>
              Further details of all the products described above can be found
              on the relevant product pages. If however, you are unsure which
              option is best for you, please do get in touch on either
              support@pedders.eu where we will do our best to assist you.
            </p>
            <InfoHeader
              size="smaller"
              text={"Further information on Wagon and STi variants."}
            />
            <p>
              Wagon models. Where relevant, we offer different parts for wagon
              models. These are heavier at the rear and also can utlise
              different lower arms. We understand this, and where necessary
              supply different or additional parts.
            </p>
            <p>
              STi models. Often the cause of confusion, later Sti models,
              specifically 200-2007 are fitted with inverted Monotube shocks.
              More importantly, the front shock uses a wider lower clevis
              bracket. This means that regular replacement shock cannot be
              fitted these models. These cars are often referred to as “wide
              track” cars, As well as the wider clevis, they are more easily
              identifies by a larger wheel stud patterm (PCD) of 114mm compared
              to 100mm on all other imprezas. If you are not sure, check this
              first (see drawing below, Where the line is 114.3).
            </p>
            <p>
              Pedders have manufactured an Ezifit kit specifically for this
              model.
            </p>
            <StyledImgParts src={part1} />
            <Gray>
              <InfoHeader
                size="smaller"
                text={
                  "Subaru Impreza GD Including WRX SportsRyder EziFit Strut Lowering Kit"
                }
              />
              <div>
                <StyledImgParts
                  src={part2}
                  alt="Subaru Impreza GD Including WRX SportsRyder EziFit Strut Lowering Kit"
                  style={{ height: "255px", width: "270px" }}
                />
              </div>
              <p style={{ fontWeight: "bolder" }}>
                Don't want a coilover kit, but still want improved suspension?
              </p>
              <p>
                Then the Pedders SportsRyder EziFit suspension kit is perfect
                for you. Our fully assembled lowering kit will reduce
                installation time and greatly improve the handling performance
                of your Impreza!
              </p>
              <hr />
              <StyledLink href="https://pedders.eu/details/803035">
                VIEW NOW
              </StyledLink>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/m0FEqfSnHLU"
              title={"Subaru Impreza Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Subaru Impreza Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Subaru Impreza Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Impreza")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <InfoFooter make="Subaru" model="Impreza" />
      </Container>
    </section>
  );
};

export default SubaruImpreza;

const StyledImgParts = styled.img`
  height: 300px;
  width: 160px;
`;

const StyledLink = styled.a`
  background-color: #dc3332;
  color: #fff;
  border-radius: 4px;
  padding: 8px 12px;
  text-decoration: none;
  font-weight: 600;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
